export function load(name) {
    if(!name) {
        throw new Error('name 为空');
    }
    const json = localStorage.getItem(name);
    if(!json) {
        return null;
    }
    let result = '';
    try {
        result = JSON.parse(json);
    } catch(ex) {
        return null;
    }

    return result;
};

export function save(name, value) {
    if(value === null || value === undefined || value === '') {
        value = null;
    } else {
        value = JSON.stringify(value);
    }

    localStorage.setItem(name, value);
};
